<template>
  <svg
    width="280"
    height="180"
    viewBox="0 0 280 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.8303 128.34H176.1C176.74 128.34 177.37 128.27 177.97 128.14C178.57 128.27 179.2 128.34 179.84 128.34H244.57C249.38 128.34 253.28 124.44 253.28 119.63C253.28 114.82 249.38 110.92 244.57 110.92H237.1C232.29 110.92 228.39 107.02 228.39 102.21C228.39 97.4002 232.29 93.5002 237.1 93.5002H260.75C265.56 93.5002 269.46 89.6002 269.46 84.7902C269.46 79.9802 265.56 76.0802 260.75 76.0802H233.37C238.18 76.0802 242.08 72.1802 242.08 67.3702C242.08 62.5602 238.18 58.6602 233.37 58.6602H153.71C158.52 58.6602 162.42 54.7602 162.42 49.9502C162.42 45.1402 158.52 41.2402 153.71 41.2402H82.7603C77.9503 41.2402 74.0503 45.1402 74.0503 49.9502C74.0503 54.7602 77.9503 58.6602 82.7603 58.6602H32.9703C28.1603 58.6602 24.2603 62.5602 24.2603 67.3702C24.2603 72.1802 28.1603 76.0802 32.9703 76.0802H64.0903C68.9003 76.0802 72.8003 79.9802 72.8003 84.7902C72.8003 89.6002 68.9003 93.5002 64.0903 93.5002H14.2803C9.47031 93.5002 5.57031 97.4002 5.57031 102.21C5.57031 107.02 9.47031 110.92 14.2803 110.92H62.8303C58.0203 110.92 54.1203 114.82 54.1203 119.63C54.1203 124.44 58.0203 128.34 62.8303 128.34ZM265.72 128.34C270.53 128.34 274.43 124.44 274.43 119.63C274.43 114.82 270.53 110.92 265.72 110.92C260.91 110.92 257.01 114.82 257.01 119.63C257.01 124.44 260.91 128.34 265.72 128.34Z"
      fill="#F9FAFB"
    />
    <path
      d="M192.23 23.5945L100.913 19.0485C98.7066 18.9387 96.8289 20.6383 96.7191 22.8447L90.2802 152.184C90.1703 154.391 91.8699 156.269 94.0763 156.378L185.393 160.924C187.6 161.034 189.477 159.335 189.587 157.128L196.026 27.7885C196.136 25.5821 194.436 23.7044 192.23 23.5945Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
    />
    <path
      d="M182.751 33.097L109.901 29.4704C107.695 29.3605 105.817 31.0601 105.707 33.2665L103.19 83.8339C103.08 86.0403 104.78 87.918 106.986 88.0279L179.836 91.6545C182.042 91.7644 183.92 90.0648 184.03 87.8584L186.547 37.291C186.657 35.0846 184.957 33.2069 182.751 33.097Z"
      fill="#EFF2F8"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M136.801 114.7L174.651 116.59"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M103.391 113.03L128.901 114.31"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M103.02 120.4L174.28 123.95"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M102.33 145.36C106.62 144.61 115.46 138.5 112.51 132.97C110.23 128.71 105.19 135.43 105.66 138.32C106.4 142.85 112.91 145.43 116.9 145.23C122.28 144.96 127.95 139.29 133.17 140.81C136.59 141.81 138.05 145.6 142.06 144.99C145.05 144.53 147.08 141.63 150.15 141.24"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M140.961 86.0402C140.401 78.8302 134.561 72.9802 127.141 72.6102C119.721 72.2402 113.331 77.4802 112.051 84.6002"
      fill="white"
    />
    <path
      d="M140.961 86.0402C140.401 78.8302 134.561 72.9802 127.141 72.6102C119.721 72.2402 113.331 77.4802 112.051 84.6002"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M127.689 68.7702C131.644 68.7702 134.849 65.5646 134.849 61.6102C134.849 57.6558 131.644 54.4502 127.689 54.4502C123.735 54.4502 120.529 57.6558 120.529 61.6102C120.529 65.5646 123.735 68.7702 127.689 68.7702Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M175.92 87.7805C175.36 80.5705 169.52 74.7205 162.1 74.3505C154.68 73.9805 148.29 79.2205 147.01 86.3405"
      fill="white"
    />
    <path
      d="M175.92 87.7805C175.36 80.5705 169.52 74.7205 162.1 74.3505C154.68 73.9805 148.29 79.2205 147.01 86.3405"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M162.65 70.5104C166.605 70.5104 169.81 67.3048 169.81 63.3504C169.81 59.3961 166.605 56.1904 162.65 56.1904C158.696 56.1904 155.49 59.3961 155.49 63.3504C155.49 67.3048 158.696 70.5104 162.65 70.5104Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M146.221 58.6804C150.175 58.6804 153.381 55.4747 153.381 51.5204C153.381 47.566 150.175 44.3604 146.221 44.3604C142.266 44.3604 139.061 47.566 139.061 51.5204C139.061 55.4747 142.266 58.6804 146.221 58.6804Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M146.382 99.9183L105.433 97.8797C104.33 97.8248 103.391 98.6746 103.336 99.7778L103.187 102.774C103.132 103.877 103.982 104.816 105.085 104.871L146.034 106.91C147.138 106.965 148.076 106.115 148.131 105.012L148.28 102.015C148.335 100.912 147.486 99.9732 146.382 99.9183Z"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M173.342 101.255L156.363 100.41C155.26 100.355 154.321 101.205 154.266 102.308L154.117 105.304C154.062 106.408 154.912 107.346 156.015 107.401L172.994 108.247C174.097 108.302 175.036 107.452 175.091 106.349L175.24 103.352C175.295 102.249 174.445 101.31 173.342 101.255Z"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M64.8594 116.75H69.3594"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M74.8594 116.75H79.3594"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M72.1094 112V107.5"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M72.1094 126V121.5"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M202.859 49.75H207.359"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M212.859 49.75H217.359"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M210.109 45V40.5"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M210.109 59V54.5"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
